import { render, staticRenderFns } from "./ViewSubmitted.vue?vue&type=template&id=783a584f&"
import script from "./ViewSubmitted.vue?vue&type=script&lang=js&"
export * from "./ViewSubmitted.vue?vue&type=script&lang=js&"
import style0 from "./ViewSubmitted.vue?vue&type=style&index=0&id=783a584f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports